import { defineMessages } from 'react-intl';

const messages = defineMessages({
  home: {
    id: 'clubskp.home',
    defaultMessage: 'Home',
    description: 'clubskp.home',
  },
  rewards: {
    id: 'clubskp.rewards',
    defaultMessage: 'Clubskp',
    description: 'clubskp.rewards',
  },
  about: {
    id: 'clubskp.about',
    defaultMessage: 'How It Works',
    description: 'clubskp.about',
  },
  news: {
    id: 'clubskp.news',
    defaultMessage: 'News',
    description: 'clubskp.news',
  },
  education: {
    id: 'clubskp.education',
    defaultMessage: 'Education',
    description: 'clubskp.education',
  },
  products: {
    id: 'clubskp.products',
    defaultMessage: 'Products',
    description: 'clubskp.products',
  },
});

export default {
  to: ['home'],
  logoSrc: '/assets/img/black/logo.svg',
  title: [
    { text: 'MY', color: '#ec2027' },
    { text: 'SKP', color: '' },
  ],
  links(group, siteId, intl) {
    return [
      {
        iconClass: 'left-nav-icons left-nav-icons--home',
        title: intl.formatMessage(messages.home),
        to: ['home'],
        links: false,
      },
      // {
      //   iconClass: 'left-nav-icons left-nav-icons--rewards',
      //   title: intl.formatMessage(messages.rewards),
      //   target: null,
      //   to: ['rewards'],
      //   links: false,
      // },
      // {
      //   iconClass: 'left-nav-icons left-nav-icons--skp',
      //   title: intl.formatMessage(messages.about),
      //   to: ['about'],
      //   links: false,
      // },
      // {
      //   iconClass: 'left-nav-icons left-nav-icons--news',
      //   title: intl.formatMessage(messages.news),
      //   to: ['news'],
      //   links: false,
      // },
      // {
      //   iconClass: 'left-nav-icons left-nav-icons--education',
      //   title: intl.formatMessage(messages.education),
      //   to: ['education'],
      //   links: false,
      // },
      {
        iconClass: 'left-nav-icons left-nav-icons--products',
        title: intl.formatMessage(messages.products),
        target: '_blank',
        to:
          siteId === 'ca'
            ? 'http://www.schwarzkopf-professional.ca/skp/ca/en/home/products/brands.html'
            : 'http://www.schwarzkopf-professionalusa.com/skp/us/en/home/products/brands.html',
        links: false,
      },
      // {
      //   iconClass: 'left-nav-icons left-nav-icons--promotions',
      //   title: 'Promotions',
      //   to: ['page', { slug: 'promotions' }],
      //   links: false,
      // },
    ];
  },
};



// WEBPACK FOOTER //
// ./src/configs/sidebar/clubskp.js